import React, { useState } from "react"
import ContentLoader from "react-content-loader"

import SliderNavigationButtons from "./SliderNavigationButtons"
import './package-card.scss'
import Translation from "../../../services/translation.service"
import { useSelector } from "react-redux"


const PackagesSlider = () => {
    const packages = useSelector(state => state?.homePage?.packages)
    
    const [selectedIndex, setSelectedIndex] = useState(0)

    const { title, price, properties, ussd_code } = packages?.[selectedIndex] || {}
    return (
        <div className="package-slider-container">
            <div className='package-card-container'>
                <div className='card-header'>
                    {packages?.length ? (
                        <>
                            <p className='card-title'>{title?.toUpperCase()}</p>
                            <p className='price'><span>{ussd_code}</span>{Translation.key('postpaid_per_month')}</p>
                        </>
                    ) : <ContentLoader
                        speed={2}
                        width={400}
                        height={160}
                        viewBox="0 0 400 160"
                        backgroundColor="#11153B"
                        foregroundColor="#ecebeb"
                    >
                        <rect x="0" y="20" rx="3" ry="3" width="100" height="6" />
                        <rect x="0" y="40" rx="3" ry="3" width="80" height="6" />
                    </ContentLoader>}
                </div>
                <div className='card-inner-container'>
                    <div className='card-body'>
                        {packages?.length ?
                            properties?.map(({ value, localise_key, unit }) => (
                                <div className='row'>
                                    <p className='card-item-title'>{Translation.key(localise_key)}</p>
                                    <p className='card-item-value'>{value} {Translation.key(unit)}</p>
                                </div>
                            )) : <ContentLoader
                                speed={2}
                                width={400}
                                height={160}
                                viewBox="0 0 400 160"
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                            >
                                <rect x="0" y="0" rx="6" ry="6" width="250" height="15" />
                                <rect x="0" y="30" rx="6" ry="6" width="250" height="15" />
                                <rect x="0" y="60" rx="6" ry="6" width="250" height="15" />
                            </ContentLoader>}
                    </div>
                    <div className='card-footer'>
                        {/* {packages.length ?
                            <Link className={`card-button`} to={packagesLink}>
                                {Translation.key("hawakom_home_btn_value_getplan")}

                            </Link>
                            : <ContentLoader
                                speed={2}
                                width={400}
                                height={20}
                                viewBox="0 0 400 20"
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                            >
                                <rect x="0" y="0" rx="6" ry="6" width="80" height="15" />
                            </ContentLoader>} */}

                    </div>
                </div>
            </div>
            <SliderNavigationButtons
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                count={packages?.length}
                isDark={true}
                isFullHeight={true}
                />
        </div>
    )
}
export default PackagesSlider